import React, { useContext } from "react";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";
import { getHeaderHtml } from "../../util/headerUtil";
import { themeColors } from "../../util/themeColors";

const CertificateLayout = ({ patient, content, format }) => {
  const { t } = useTranslation();
  const authCtx = useContext(AuthContext);
  const hospitalData = authCtx.hospitalData || {};

  const isA5 = format === 'a5';

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        width: "100%",
        padding: "0",
        backgroundColor: "#fff",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <div dangerouslySetInnerHTML={{ __html: getHeaderHtml(hospitalData) }} />

      {/* Decorative Border Wrapper for Content */}
      <div style={{
        margin: "10px",
        padding: isA5 ? "15px" : "20px",
        border: `2px solid ${themeColors[hospitalData.applicationThemeColour || 'TEAL']?.primary || '#006d77'}`,
        borderRadius: "4px",
        backgroundColor: "#fff",
        minHeight: isA5 ? "120mm" : "180mm",
        display: "flex",
        flexDirection: "column"
      }}>
        {/* Patient Info */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: isA5 ? "12px" : "13px",
            marginBottom: isA5 ? "10px" : "15px",
            paddingBottom: "8px",
            borderBottom: "1px solid #eee",
            lineHeight: "1.5",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <p style={{ margin: "2px 0", color: "#444" }}>
              <strong style={{ color: "#000", fontSize: isA5 ? "13px" : "14px" }}>{t("Name")}:</strong> {patient?.firstName || ""} {patient?.middleName || ""} {patient?.lastName || ""}
            </p>
            <p style={{ margin: "2px 0", color: "#444" }}>
              <strong style={{ color: "#000", fontSize: isA5 ? "13px" : "14px" }}>{t("Address")}:</strong> {patient?.address || "-"}
            </p>
          </div>
          <div style={{ textAlign: "right" }}>
            <p style={{ margin: "2px 0", color: "#444" }}>
              <strong style={{ color: "#000", fontSize: isA5 ? "13px" : "14px" }}>{t("Mobile")}:</strong> {patient?.mobile || "-"}
            </p>
            <p style={{ margin: "2px 0", color: "#444" }}>
              <strong style={{ color: "#000", fontSize: isA5 ? "13px" : "14px" }}>{t("Date")}:</strong> {new Date().toLocaleDateString('en-GB')}
            </p>
          </div>
        </div>

        {/* Certificate Content - Cursive Font */}
        <div style={{
          marginTop: "10px",
          fontSize: isA5 ? "16px" : "18px",
          lineHeight: isA5 ? "1.5" : "1.8",
          fontFamily: "'Brush Script MT', 'Comic Sans MS', cursive",
          color: "#2c3e50",
          textAlign: "justify",
          flexGrow: 1
        }}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default CertificateLayout;
